export const COUNTRY_ALREADY_EXISTS_MESSAGE =
    'This country already exists. You cannot create another destination for it.';

export const CLONE_COUNTRY_REQUIRED_MESSAGE =
    'Choose a unique country for this cloned destination before saving.';

export const normalizeCountryKey = (country) =>
    String(country || '')
        .trim()
        .toLowerCase();

export const isCountryTaken = (country, takenCountries = [], { allowCountry = null } = {}) => {
    const key = normalizeCountryKey(country);
    if (!key) return false;

    const allowed = normalizeCountryKey(allowCountry);
    if (allowed && key === allowed) return false;

    return (takenCountries || []).some(
        (existing) => normalizeCountryKey(existing) === key
    );
};

/** Build a unique list of countries already used by other destinations. */
export const collectTakenCountries = (trips = [], { excludeTripId = null } = {}) => {
    const seen = new Set();
    const result = [];

    (trips || []).forEach((trip) => {
        if (excludeTripId != null && String(trip?.id) === String(excludeTripId)) {
            return;
        }
        const country = String(trip?.primary_country || '').trim();
        if (!country) return;
        const key = normalizeCountryKey(country);
        if (seen.has(key)) return;
        seen.add(key);
        result.push(country);
    });

    return result;
};
